export default __webpack_public_path__ + "static/media/logout.baf043ff.svg";